import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import * as Assets from "Data/Assets";
import { Button } from "GameObjects/Button";
import { MusicGameCharacter } from "GameObjects/MusicGame/Character";
import { MusicGameLoopButton } from "GameObjects/MusicGame/Buttons/LoopButton";
import { MusicGameNoLoopButton } from "GameObjects/MusicGame/Buttons/NoLoopButton";
import * as TestJSON from "json/testSong.json";
import { MusicManager } from "Singletons/MusicManager";
// import AudioPreloadManager from "Singletons/AudioPreloadManager";
import { MusicGameTimeline } from "GameObjects/MusicGame/Timeline";
import { MusicGamePlayButton } from "GameObjects/MusicGame/Buttons/PlayButton";
import { MusicGamePlaybackPlayButton } from "GameObjects/MusicGamePlayback/Buttons/PlayButton";
import { MusicGameAmy } from "GameObjects/MusicGame/Characters/Amy";
import { MusicGameHolly } from "GameObjects/MusicGame/Characters/Holly";
import { MusicGameOscar } from "GameObjects/MusicGame/Characters/Oscar";
import { MusicGamePiper } from "GameObjects/MusicGame/Characters/Piper";
import { MusicGameTyler } from "GameObjects/MusicGame/Characters/Tyler";
import { MusicGameOverlaySpotlight } from "GameObjects/MusicGame/OverlaySpotlight";
import { MusicGameRampedSpotlight } from "GameObjects/MusicGame/RampedSpotlight";
import { MusicGameBackground } from "GameObjects/MusicGame/Background";

export class MusicGamePlayback extends HLF.State {
    private readonly _buttons: Button[];
    private readonly _timeline: MusicGameTimeline;
    private readonly _characters: MusicGameCharacter[];

    constructor() {
        super();

        this._buttons = new Array<Button>();

        const bg = this.addChild(new MusicGameBackground());

        const helloText = HLF.PixiUtils.makeText(`Music Game (Playback)`, Constants.FONT_GEL_MED_35, 35, 0xffffff);
        this.addChild(helloText);
        helloText.y = -350;
        const spotOverlayAmy = this.addChild(new MusicGameOverlaySpotlight({id: 1, name: 'amy'}));
        const spotOverlayOscar = this.addChild(new MusicGameOverlaySpotlight({id: 3, name: 'oscar'}));
        const spotOverlayPiper = this.addChild(new MusicGameOverlaySpotlight({id: 4, name: 'piper'}));
        const spotOverlayTyler = this.addChild(new MusicGameOverlaySpotlight({id: 0, name: 'tyler'}));
        const spotOverlayHolly = this.addChild(new MusicGameOverlaySpotlight({id: 2, name: 'holly'}));
        const spotRampedAmy = this.addChild(new MusicGameRampedSpotlight({id: 1, name: 'amy'}));
        const spotRampedOscar = this.addChild(new MusicGameRampedSpotlight({id: 3, name: 'oscar'}));
        const spotRampedPiper = this.addChild(new MusicGameRampedSpotlight({id: 4, name: 'piper'}));
        const spotRampedTyler = this.addChild(new MusicGameRampedSpotlight({id: 0, name: 'tyler'}));
        const spotRampedHolly = this.addChild(new MusicGameRampedSpotlight({id: 2, name: 'holly'}));
        const amy = this.addChild(new MusicGameAmy({id: 1}));
        const oscar = this.addChild(new MusicGameOscar({id: 3}));
        const piper = this.addChild(new MusicGamePiper({id: 4}));
        const tyler = this.addChild(new MusicGameTyler({id: 0}));
        const holly = this.addChild(new MusicGameHolly({id: 2}));
        spotOverlayHolly.position.set(0, -384);
        spotOverlayTyler.position.set(-350, -384);
        spotOverlayPiper.position.set(350, -384);
        spotOverlayOscar.position.set(140, -384);
        spotOverlayAmy.position.set(-150, -384);

        spotRampedTyler.position.set(-350, -384);
        spotRampedAmy.position.set(-150, -384);
        spotRampedHolly.position.set(0, -384);
        spotRampedOscar.position.set(140, -384);
        spotRampedPiper.position.set(350, -384);

        tyler.position.set(-345, 137);
        amy.position.set(-180, 55);
        holly.position.set(0, 135);
        oscar.position.set(170, 67);
        piper.position.set(315, 130);

        this._characters = [
            tyler,
            amy,
            holly,
            oscar,
            piper,
        ]

        this._timeline = this.addChild(new MusicGameTimeline());
        this._timeline.position.set(0, 250);
        this._timeline.SetData(MusicManager.Instance.data);

        const playButton = this.addChild(new MusicGamePlaybackPlayButton());
        playButton.position.set(0, 100);
        this._buttons = [
            playButton,
        ]
    }

    /**
     * Currently acts like a delayed contructor.
     * @param pSize The current window size.
     */
    public init(pSize: PIXI.Point) {
        super.init(pSize);

        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, this._buttons);

        // AudioPreloadManager.debug = false;
        // AudioPreloadManager.paused = false;

        this.onResize(pSize);

        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, [
            ...this._characters,
            ...this._buttons
        ]);
    }

    /**
     * Called when a state is destroyed.
     */
    public destroy(pOptions?: {children?: boolean; texture?: boolean; baseTexture?: boolean;}): void {
        super.destroy(pOptions);

        PubSub.publishSync(HLF.CLEAR_FOCUS, undefined);
        PubSub.publishSync(HLF.UNREGISTER_ALL_FOCUSABLES, undefined);
    }

    /**
     * Called when the window is resized.
     * @param pSize The new size.
     */
    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    /**
     * Called after load screen has animated out.
     * If no animation is required, simply remove this function.
     * @param pOnComplete Callback when completed.
     */
    public animateIn(pOnComplete: () => void): void {
        // MusicManager.Instance.Play();
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            timeline.to(element.scale, 0.5, {
                x: 1,
                y: 1,
            }, 0.1 * i);
        }
        timeline.call(this.onAnimateInComplete.bind(this));
        timeline.eventCallback(Constants.TWEEN_ONCOMPLETE, pOnComplete);
    }

    /**
     * Called when transition to leave starts.
     * If no animation is required, simply remove this function.
     * @param pOnComplete Callback when completed.
     */
    public animateOut(pOnComplete: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            element.interactive = false;
            timeline.to(element.scale, 0.5, {
                x: 0,
                y: 0,
            }, 0.1 * i);
        }
        timeline.eventCallback(Constants.TWEEN_ONCOMPLETE, pOnComplete);
    }

    /**
     * Called once per frame.
     * @param pDeltaTime Time it took to render the previous frame.
     */
    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this._timeline.update(pDeltaTime);

        MusicManager.Instance.update(pDeltaTime / 1000);
        // AudioPreloadManager.update();
        for(let i=0; i<this._characters.length; i++) {
            this._characters[i].update(pDeltaTime);
        }
    }

    private onAnimateInComplete(): void {
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            element.interactive = true;
        }
    }
}
